import { associatedColours } from '../../constants'
import LockSVG from '../../icons/LockSVG'
import { usePeerAnalyserStore } from '../../state-management/peerAnalyserStore'
import { openEliteLandingPage, trackEvent } from '../../utils/appBridge'
import EliteOfferBadge from '../ui-components/EliteOfferBadge'
import EliteOfferExhausted from '../ui-components/EliteOfferExhausted'
import { EventNames } from '../../types/misc.types'
import { getBottomPadding } from '../../utils/sessionStorage'

interface PeerAnalyserUnlockProps {
  // If you need to pass any props from the parent, define them here.
  // For now, based on the original snippet, it mostly relies on store state.
}

const PeerAnalyserUnlock: React.FC<PeerAnalyserUnlockProps> = () => {
  const { isUserElite, isSubscribedToPeerAnalyser, isUserExhaustedPASubs, selectedCategoryId, tenureInDays } =
    usePeerAnalyserStore()

  if (isUserElite) {
    return null // If user is Elite, nothing is rendered based on your original logic
  }

  if (isSubscribedToPeerAnalyser && isUserExhaustedPASubs) {
    return null // Subscribed and exhausted means no unlock button
  }

  const fundCategoryLabel = associatedColours[selectedCategoryId]?.label || 'Fund' // Fallback for safety

  return (
    <div className='relative'>
      <div
        style={{ top: `${getBottomPadding() ? -1 * (getBottomPadding() + 100) : -100}px` }}
        className='absolute w-full -translate-x-1/2 -translate-y-1/2 left-[-60px]'
      >
        <button
          onClick={() => {
            // Track unlock elite click
            trackEvent({
              eventName: EventNames.ButtonTap,
              payload: {
                ScreenName: 'PeerAnalyser',
                buttonLabel: 'Unlock Elite',
                eventId: selectedCategoryId
              }
            })
            openEliteLandingPage()
          }}
          className='max-w-[120px] w-[120px] bg-[#FFF2DF] text-[#722200] rounded-xl px-3 py-[9px] text-xs font-medium border-1 border-solid border-[#F7CB88] flex justify-center focus:outline-none'
        >
          <div className='flex flex-row gap-2 justify-center items-center'>
            <span className='inline mt-[2px]'>
              <LockSVG color={'#722200'} />
            </span>
            <span className='inline text-[13px]'>Unlock Elite</span>
          </div>
        </button>
      </div>

      <div className='absolute right-[-72px] top-[calc(-45vh)] -translate-x-1/2 -translate-y-1/2 z-50'>
        {isUserExhaustedPASubs ? (
          <EliteOfferExhausted fundCategory={fundCategoryLabel} />
        ) : (
          <EliteOfferBadge fundCategory={fundCategoryLabel} tenureInDays={tenureInDays} />
        )}
      </div>
    </div>
  )
}

export default PeerAnalyserUnlock
